import {Layout, FloatingFocusManager, useFloatingContext} from '~/components'
import {PopoutContent} from '../popout_content'

export const PopoutLayout = ({type, width, ...rest}) => {
	const {refs, isOpen, floatingStyles, getFloatingProps} = useFloatingContext()

	if (!isOpen) return null

	const floatingProps = getFloatingProps()

	return (
		<FloatingFocusManager>
			<div onClick={e => e.stopPropagation()}>
				<Layout
					ref={refs.setFloating}
					className="popout-layout"
					background="white"
					direction="vertical"
					gap={0}
					width={width}
					style={floatingStyles}
					border
					borderRadius
					colorSet={false}
					hasHover={false}
					{...floatingProps}
				>
					<PopoutContent type={type} {...rest} />
				</Layout>
			</div>
		</FloatingFocusManager>
	)
}
